module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (105).034a1173.jpg";